import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Checkbox, FormControlLabel, Stack, Tooltip } from "@mui/material";
import { t } from "i18next";
import { iresoftColors } from "../../../theme/ireColors";
import { infoToast } from "../Toastify/Toastify";

interface AcceptanceCheckboxProps {
  acceptance: boolean;
  setAcceptance: (value: boolean) => void;
}

const AcceptanceCheckbox: React.FC<AcceptanceCheckboxProps> = ({
  acceptance,
  setAcceptance,
}) => {
  return (
    <Stack spacing={0.2} sx={{ mt: -1.5 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={acceptance}
            onChange={(e) => setAcceptance(e.target.checked)}
            required
          />
        }
        sx={{ alignItems: "center" }}
        label={
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <Tooltip
              title={t("pages.currentlyReading.form.acceptanceTooltip")}
              arrow
              slotProps={{ tooltip: { sx: { fontSize: "14px" } } }}
            >
              <HelpOutlineIcon
                sx={{ fontSize: "16px", mr: 0.5, color: iresoftColors.black80 }}
                onClick={() =>
                  infoToast(t("pages.currentlyReading.form.acceptanceTooltip"))
                }
              />
            </Tooltip>
            {t("pages.currentlyReading.form.acceptanceText")}
          </span>
        }
      />
    </Stack>
  );
};

export default AcceptanceCheckbox;
